module.exports = __webpack_public_path__ + "img/ig-icon.afac8448.png";